import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Home from '@/components/Home'
import fooDate from '@/components/Foo'
//import leftnav from "./components/leftNav.vue"
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/bar',
      name: 'Hello',
      component: HelloWorld
    },
    {
      path: '/',    //这里配置一个默认的路由 "/" 以及官方的路由重定向 是一个道理
      name: 'Home',
      component: Home,
      redirect:"/home",
    },
    {
      path: '/foo',
      name: 'fooDate',
      component: fooDate
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home,
     
    },
  ]
})
//redirect:"/home",



// WEBPACK FOOTER //
// ./src/router/index.js